export default zipcode => {
  return {
    billingZipCode: zipcode || ''
  };
};
